// extracted by css-extract-rspack-plugin
export default {"affirmative":"Affirmative-module__affirmative__aUo9D","copilotRun":"Affirmative-module__copilotRun__l9COr"};